/* eslint-disable import/prefer-default-export */
import { useRouter } from 'next/router'
import useSession from 'querys/session'
import { useMutation } from 'react-query'
import { createCertificateService } from 'services/certificates'

export function useCreateCertificate() {
  const { query: { certificate_uuid: uuid } } = useRouter()
  const { token } = useSession()
  return useMutation(
    () => createCertificateService({ uuid, token }),
  )
}
